import { Container } from '@components/Container'
import { BannerEnum } from '@interfaces/BannerEnum'
import { HighlightBannerForm } from '@features/home/components/HighlightBannerForm'
import { EditHighlightBannerPageProps } from './interface'

export function EditHighlightBannerPage({
  type,
  initialValues,
  onSubmit,
}: EditHighlightBannerPageProps) {
  return (
    <Container>
      <section className='flex items-center justify-between mb-5'>
        <Container.Title showBackBtn>
          แก้ไขแบนเนอร์แบบ
          {type === BannerEnum.POSTER ? ' Poster' : 'ปกหนังสือ'}
        </Container.Title>
      </section>

      <HighlightBannerForm initialValues={initialValues} onSubmit={onSubmit} />
    </Container>
  )
}
